module.exports = __webpack_public_path__ + "static/section_about-caadd95aa0e175588913bdd9e79822d6.jpg";